import createVueComponent from '../createVueComponent';

const FileCode = createVueComponent('FileCodeIcon', [
  ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
  ['path', { d: 'M14 2v6h6' }],
  ['path', { d: 'M9 18l3-3-3-3' }],
  ['path', { d: 'M5 12l-3 3 3 3' }],
]);

export default FileCode;
